import { useParams } from "react-router-dom";
import { useGetBingoGameQuery } from "bingo/api/bingo-game.api";

export function useBingoGamePoll(pollingInterval?: number) {
  const { bingoGameId } = useParams<{ bingoGameId: string }>();

  return useGetBingoGameQuery(bingoGameId!, {
    pollingInterval: pollingInterval ?? 0, // If no interval provided, polling is disabled
    refetchOnMountOrArgChange: true,
  }).data;
}
